var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { prevent } from '../../common/utils';
import classNames from "classnames";
import { Label } from '../Text';
import { Button } from '../Button';
import { CircularProgress } from '../CircularProgress';
import { AiOutlineClose, AiOutlineEye, AiOutlineEyeInvisible } from '../../icons';
import { ButtonItemProps, HintSize, IconSize, LabelSize, SuffixSize, defaultBottomClasses, defaultItemClasses, defaultLeftClasses, defaultRightClasses, defaultTopClasses, PrefixSize, } from './text-input.config';
var RenderItem = function (_a) {
    var onClick = _a.onClick, content = _a.content, _b = _a.orientation, orientation = _b === void 0 ? 'left' : _b;
    if (Array.isArray(content)) {
        return _jsx(_Fragment, { children: content.map(function (item, key) { return _jsx(RenderItem, { onClick: onClick, content: item, orientation: orientation }, key); }) });
    }
    else if (content)
        return _jsx("div", __assign({ onClick: onClick, className: classNames(defaultItemClasses, "__input__content_item_".concat(orientation)) }, { children: content }));
    return null;
};
export var LeftContent = function (_a) {
    var size = _a.size, prefix = _a.prefix, prefixProps = _a.prefixProps, _b = _a.contentLeft, contentLeft = _b === void 0 ? null : _b, _c = _a.preventClickLeftContent, preventClickLeftContent = _c === void 0 ? false : _c;
    var prefixNode = null;
    if (prefix) {
        var textProps = __assign({ textSize: PrefixSize[size] }, prefixProps);
        prefixNode = (_jsx(RenderItem, { content: _jsx(Label, __assign({}, textProps, { label: prefix })) }));
    }
    if (prefixNode || contentLeft)
        return (_jsxs("div", __assign({ className: defaultLeftClasses }, { children: [prefixNode, _jsx(RenderItem, { content: contentLeft, onClick: function (e) { return preventClickLeftContent && prevent(e); } })] })));
    return null;
};
export var RightContent = function (_a) {
    var password = _a.password, size = _a.size, disabled = _a.disabled, loading = _a.loading, variant = _a.variant, suffix = _a.suffix, suffixProps = _a.suffixProps, _b = _a.contentRight, contentRight = _b === void 0 ? null : _b, clearable = _a.clearable, clearableProps = _a.clearableProps, passwordButtonProps = _a.passwordButtonProps, onClear = _a.onClear, filled = _a.filled, isPasswordVisible = _a.isPasswordVisible, tooglePasswordVisibility = _a.tooglePasswordVisibility, _c = _a.preventClickRightContent, preventClickRightContent = _c === void 0 ? false : _c;
    var suffixNode = null;
    if (suffix) {
        var textProps = __assign({ textSize: SuffixSize[size] }, suffixProps);
        suffixNode = (_jsx(RenderItem, { orientation: "right", content: _jsx(Label, __assign({}, textProps, { label: suffix })) }));
    }
    var clearableNode = null;
    if (clearable && filled && !disabled && !loading) {
        var baseProps = __assign(__assign({}, ButtonItemProps[variant]), clearableProps);
        clearableNode = (_jsx(RenderItem, { orientation: "right", content: _jsx(Button, __assign({ noneTheme: true, flat: true, noFocuseable: true, borderRadius: 5, padding: 2 }, baseProps, { minHeight: 0, onClick: onClear }, { children: _jsx(AiOutlineClose, { size: IconSize[size] }) })) }));
    }
    var passwordNode = null;
    if (password && !loading) {
        var baseProps = __assign(__assign({}, ButtonItemProps[variant]), passwordButtonProps);
        var PasswordIcon = isPasswordVisible ? AiOutlineEyeInvisible : AiOutlineEye;
        passwordNode = (_jsx(RenderItem, { orientation: "right", content: _jsx(Button, __assign({ flat: true, noFocuseable: true, borderRadius: 5, padding: 2, paddingBottom: 0 }, baseProps, { minHeight: 0, onClick: function () { return tooglePasswordVisibility && tooglePasswordVisibility(!isPasswordVisible); } }, { children: _jsx(PasswordIcon, { size: IconSize[size] }) })) }));
    }
    var loadingNode = null;
    if (loading) {
        loadingNode = (_jsx(RenderItem, { orientation: "right", content: _jsx(CircularProgress, { color: "inherit", size: 12, thickness: 5 }) }));
    }
    if (suffixNode || contentRight || clearableNode || passwordNode || loadingNode)
        return (_jsxs("div", __assign({ className: defaultRightClasses }, { children: [suffixNode, clearableNode, passwordNode, loadingNode, _jsx(RenderItem, { orientation: "right", content: contentRight, onClick: function (e) { return preventClickRightContent && prevent(e); } })] })));
    return null;
};
export var TopContent = function (_a) {
    var size = _a.size, disabled = _a.disabled, variant = _a.variant, label = _a.label, labelProps = _a.labelProps, _b = _a.contentTop, contentTop = _b === void 0 ? null : _b;
    var labelNode = null;
    if (label) {
        var textProps = __assign({ textSize: LabelSize[size] }, labelProps);
        labelNode = (_jsx(RenderItem, { content: _jsx(Label, __assign({}, textProps, { label: label })) }));
    }
    if (labelNode || contentTop)
        return (_jsxs("div", __assign({ className: defaultTopClasses }, { children: [labelNode, _jsx(RenderItem, { content: contentTop })] })));
    return null;
};
export var BottomContent = function (_a) {
    var size = _a.size, hint = _a.hint, error = _a.error, hintProps = _a.hintProps, errorProps = _a.errorProps, _b = _a.contentBottom, contentBottom = _b === void 0 ? null : _b, maxLength = _a.maxLength, requiredLength = _a.requiredLength, currentLength = _a.currentLength, showCounter = _a.showCounter;
    var hintNode = null;
    if (hint && !showCounter) {
        var textProps = __assign({ textSize: HintSize[size], textColor: 'surface-7' }, hintProps);
        hintNode = (_jsx(RenderItem, { content: _jsx(Label, __assign({}, textProps, { label: hint })) }));
    }
    var counterNode = null;
    if (showCounter) {
        var textProps = __assign({ textSize: HintSize[size], textColor: 'surface-7' }, hintProps);
        if (requiredLength > 0)
            counterNode = (_jsx(RenderItem, { content: _jsx(Label, __assign({}, textProps, { label: "".concat(currentLength, " de ").concat(requiredLength, " requerido.") })) }));
        else if (maxLength > 0)
            counterNode = (_jsx(RenderItem, { content: _jsx(Label, __assign({}, textProps, { label: "".concat(currentLength, " de ").concat(maxLength, ".") })) }));
    }
    var errorNode = null;
    if (error) {
        var textProps = __assign({ textSize: HintSize[size], textColor: 'red-7' }, errorProps);
        errorNode = (_jsx(RenderItem, { content: _jsx(Label, __assign({}, textProps, { label: error })) }));
    }
    if (hintNode || errorNode || counterNode || contentBottom)
        return (_jsxs("div", __assign({ className: defaultBottomClasses }, { children: [errorNode, !errorNode && _jsxs(_Fragment, { children: [counterNode, hintNode, _jsx(RenderItem, { content: contentBottom })] })] })));
    return null;
};
